/** THÈMES — chaque pro habille sa page et ses visuels à ses couleurs.
 *  Le thème ne touche que l'accent et la typo : la structure « Cloud / Soft Minimal » reste. */
export const THEMES = {
  sauge: { nom: "Sauge", accent: "#37544A", doux: "#E7EDE8", voile: "#D7E3D9" },
  encre: { nom: "Encre", accent: "#202020", doux: "#E8E8E6", voile: "#DFDFDB" },
  rose: { nom: "Rose poudré", accent: "#8B4A52", doux: "#F3E4E4", voile: "#EEDBDA" },
  sable: { nom: "Sable", accent: "#7C603E", doux: "#F1E8D9", voile: "#EEE3D0" },
  nuit: { nom: "Bleu nuit", accent: "#26344E", doux: "#E2E8F2", voile: "#D6DFEC" },
  terracotta: { nom: "Terracotta", accent: "#96543A", doux: "#F4E3DB", voile: "#F0DCD1" },
};

/** Duos de polices proposés par Brand Auto. Doit rester aligné sur backend/services/palette.py. */
export const DUOS = {
  editorial: { nom: "Éditorial", titre: "Playfair Display", texte: "Figtree" },
  moderne: { nom: "Moderne", titre: "Space Grotesk", texte: "Figtree" },
  douceur: { nom: "Douceur", titre: "Cormorant Garamond", texte: "Jost" },
  caractere: { nom: "Caractère", titre: "Fraunces", texte: "Manrope" },
  epure: { nom: "Épuré", titre: "DM Serif Display", texte: "Karla" },
};

const DEJA = new Set();

/** Les polices d'une marque perso sont chargées à la demande : la page publique
 *  d'un pro ne paie pas les 5 duos possibles. */
export function chargerPolices(marque) {
  if (!marque) return;
  [marque.police_titre, marque.police_texte].forEach((famille) => {
    if (!famille || DEJA.has(famille)) return;
    DEJA.add(famille);
    const lien = document.createElement("link");
    lien.rel = "stylesheet";
    lien.href = `https://fonts.googleapis.com/css2?family=${famille.replace(
      / /g,
      "+"
    )}:wght@400;500;600;700&display=swap`;
    document.head.appendChild(lien);
  });
}

/** À poser sur le conteneur racine d'une page publique. */
export function styleTheme(code, marque) {
  if (code === "perso" && marque?.accent) {
    chargerPolices(marque);
    return {
      "--accent": marque.accent,
      "--accent-hover": marque.accent,
      "--accent-soft": marque.doux,
      "--font-display": `"${marque.police_titre}", ui-serif, Georgia, serif`,
      "--font-editorial": `"${marque.police_titre}", ui-serif, Georgia, serif`,
      "--font-ui": `"${marque.police_texte}", ui-sans-serif, system-ui, sans-serif`,
      background: "var(--bg)",
    };
  }
  const t = THEMES[code] || THEMES.sauge;
  return {
    "--accent": t.accent,
    "--accent-hover": t.accent,
    "--accent-soft": t.doux,
    background: "var(--bg)",
  };
}
